import { Component, OnInit, OnDestroy } from '@angular/core'
import { StepperService } from '../../../services/stepper.service'
import { Subject, takeUntil } from 'rxjs'

@Component({
    selector: 'app-new-key-system',
    templateUrl: './new-key-system.component.html',
    styleUrls: ['./new-key-system.component.scss'],
    standalone: false
})
export class NewKeySystemComponent implements OnInit, OnDestroy {
  private onDestroy$ = new Subject<void>()

  steps = [
    { name: 'System', current: true, complete: false, step: 0 },
    { name: 'TMK', current: false, complete: false, step: 1 },
    { name: 'Attachments', current: false, complete: false, step: 2 },
    { name: 'CKs', current: false, complete: false, step: 3 },
  ]

  public types = [
    { id: 1, name: '--' },
    { id: 2, name: 'Excel Upload' },
    { id: 3, name: 'PDF Conversion' },
    { id: 4, name: 'No Schedule' },
  ]

  step = this.steps[0]

  constructor(private stepperService: StepperService) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.stepperService.setStep(this.step)
    this.stepperService.setSteps(this.steps)

    this.stepperService
      .getStep()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((step) => {
        this.step = step
      })

    this.stepperService
      .getSteps()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((steps) => {
        this.steps = steps
      })
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.unsubscribe()
  }

  /* istanbul ignore next */
  onChangeStep(event) {
    this.stepperService.select(event)
  }

  /* istanbul ignore next */
  back() {
    this.stepperService.back()
  }

  next() {
    this.stepperService.next()
  }
}
